import { useMemo } from "react";

import styled from "styled-components";

import { useRouteSectionKey } from "NavBar/navBarStore";
import {
  fullScreenMargin,
  navigationGradientColors,
  toolbarButtonSize,
} from "NavBar/styleConstants";

import FnrIconButton from "UI/FnrIconButton";
import FnrOpacityToggle from "UI/FnrOpacityToggle";
import FnrTappyShrink from "UI/FnrTappyShrink";
import { navAccentColors } from "UI/colors";

const NavCloseButton = ({
  isExpanded,
  isFullScreen,
  isComposerMinimized,
  navBarIsFullyLoaded,
  appIsReady,
  handleClick,
}) => {
  const routeSectionKey = useRouteSectionKey();
  const show = useMemo(() => {
    if (isComposerMinimized) return false;
    if (isExpanded && isFullScreen && navBarIsFullyLoaded) return true;
    return false;
  }, [isComposerMinimized, isExpanded, isFullScreen, navBarIsFullyLoaded]);

  return (
    <FnrOpacityToggle show={show && appIsReady}>
      <ClosePositioner>
        <FnrTappyShrink scale={0.9}>
          <CloseButton data-cy="NavBar_NavToggle_CloseButton">
            <FnrIconButton
              icon="chevron-left fas"
              aria-label="collapse-navigation-menu"
              aria-expanded={isExpanded}
              onClick={handleClick}
              backgroundColor={navigationGradientColors[0]}
              hoverFocusBackgroundColor={navigationGradientColors[1]}
              color={
                navAccentColors[routeSectionKey]?.[0] ||
                navAccentColors.groups[0]
              }
              hoverFocusColor={
                navAccentColors[routeSectionKey]?.[0] ||
                navAccentColors.groups[0]
              }
              scaleIconOnly
              size="md"
            />
          </CloseButton>
        </FnrTappyShrink>
      </ClosePositioner>
    </FnrOpacityToggle>
  );
};

const ClosePositioner = styled.div`
  position: absolute;
  right: 0;
  margin-right: -${toolbarButtonSize / 2 - fullScreenMargin - 4}px;
  top: 38px;
  z-index: 2;
`;

const CloseButton = styled.div`
  border-radius: ${toolbarButtonSize / 2}px;
  box-shadow: rgb(0 0 0 / 40%) 0 0 4px;
  background: ${navigationGradientColors[0]};
  cursor: pointer;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);

  button {
    height: 36px;
    width: 36px;
  }
`;

export default NavCloseButton;
